import React from 'react';

const events = [
  {
    month: 'Feb',
    day: '7',
    title: 'HeART Fest',
    url: 'https://www.artisansguildcamas.org/heartfest',
    details: '10 am\u20135 pm \u00b7 56 S 1st., Washougal, WA 98671',
  },
  {
    month: 'May',
    day: '2-3',
    title: 'Washougal Studio Artists Spring Studio Tour',
    url: 'https://www.washougalstudioartists.org/2026-spring-studio-tour',
    details: '10 am\u20134 pm \u00b7 Washougal, WA',
  },
  {
    month: 'May',
    day: '9',
    title: 'Camas Plant and Garden Fair',
    url: 'https://cwplantfair.org/',
    details: '9 am\u20134 pm \u00b7 Downtown Camas, WA 98607',
  },
  {
    month: 'May',
    day: '30-31',
    title: 'Artists Greenhouse Sale',
    url: 'https://www.artistsghsale.com/',
    details: 'May 30: 9 am\u20134 pm \u00b7 May 31: 11 am\u20133 pm \u00b7 1335 S. Woodbine Rd, West Linn, OR 97068',
  },
  {
    month: 'Jul',
    day: '25-26',
    title: 'Chehalem Mountain Art Affair',
    url: 'https://www.facebook.com/ChehalemMountainArtAffair/',
    details: 'July 25: 9 am\u20135 pm \u00b7 July 26: 10 am\u20135 pm \u00b7 19438 SW Neugebauer Rd., Hillsboro, OR 97123',
  },
  {
    month: 'Aug',
    day: '29',
    title: 'Camas Vintage and Art Faire',
    url: 'https://downtowncamas.com/event/camas-vintage-art-faire/',
    details: '9 am\u20133 pm \u00b7 Downtown Camas, WA 98607',
  },
];

function Events() {
  return (
    <section className="section events" id="events">
      <div className="section-header">
        <h2>2026 Events Calendar</h2>
        <p>I will be selling my artwork at the following shows in 2026. I hope to see you there!</p>
        <div className="section-divider" />
      </div>
      <div className="events-list">
        {events.map((event, i) => (
          <div className="event-item" key={i}>
            <div className="event-date">
              <span className="month">{event.month}</span>
              <span className="day">{event.day}</span>
            </div>
            <div className="event-info">
              <h3>
                <a href={event.url} target="_blank" rel="noopener noreferrer">
                  {event.title}
                </a>
              </h3>
              <p>{event.details}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Events;
